import gql from 'graphql-tag';

/**
 * Data of the block project-clarification: `deferredState` with its four fields. Read through
 * `Project.blocks.clarification`, which checks the block's read permission.
 */
export const PROJECT_CLARIFICATION_FIELDS = gql`
  fragment projectClarificationFields on ProjectClarificationBlock {
    id
    number
    deferredState {
      deferred
      reason
      description
      comment
    }
  }
`;
